import { Table } from 'antd'
import { useQuery } from '@apollo/client'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {Top} from '../../components/Top'
import { useState, useEffect } from 'react'
import { useUser } from '../../utils/hooks'
import { FIND_MANY_CITIES } from '../../gqls/cities'

const limit = 50
const City = () => {
  const { user } = useUser()
  const { id } = useParams()
  const navigate = useNavigate()
  const [skip, setSkip] = useState(0)

  useEffect(() => {
    if (!user?.role?.canReview) navigate(-1)
  })

  const { data, loading } = useQuery(FIND_MANY_CITIES, {
    fetchPolicy: 'network-only',
    variables: { take: limit, skip, where:{country:{id:{equals:id}}} },
  })

  const onChangeTable = (pagination) => {
    setSkip((pagination.current - 1) * limit)
  }

  const record = data ? data?.findManyCities : []
  const total = data ? data?.findManyCities.length : 0
  const columns = [
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
    },
  ]

  if (user?.role?.canReview) {
    columns.push({
      title: 'Действие',
      key: 'operation',
      align: 'center',
      render: (record) => <Link to={`/cities/update/${record.id}`}>Изменить</Link>,
    })
  }

  const getButtons = () => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {user?.role?.canReview && <Link to={`/cities/create/${id}`}>Добавить</Link>}
    </div>
  )

  return (
    <>
      <Top title='Города' action={getButtons()} />
      <Table
        dataSource={record}
        loading={loading}
        onChange={onChangeTable}
        pagination={{
          total,
          pageSize: limit,
        }}
        scroll={{ x: 600 }}
        rowKey={(row) => row.id}
        columns={columns}
      />
    </>
  )
}

export default City
